import { Navigate, useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { authApi } from '@/api/auth'
import { errorMessage } from '@/api/client'
import { useAuthStore } from '@/store/auth'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRoles?: Array<'operator' | 'finance' | 'super_admin'>
}
export function ProtectedRoute({
  children,
  requiredRoles,
}: ProtectedRouteProps) {
  const { token, login } = useAuthStore()
  const location = useLocation()
  const session = useQuery({
    queryKey: ['admin-session', token],
    enabled: !!token,
    retry: false,
    staleTime: 0,
    queryFn: async () => {
      const res = await authApi.me()
      if (!res.data || res.code !== 0)
        throw new Error(res.message || '会话校验失败')
      login(token!, res.data)
      return res.data
    },
  })
  if (!token) return <Navigate to="/login" state={{ from: location }} replace />
  if (session.isPending)
    return <div className="p-8 text-slate-500">正在验证管理员身份…</div>
  if (session.isError)
    return (
      <div className="p-8" role="alert">
        {errorMessage(session.error)}{' '}
        <button className="text-brand-600" onClick={() => session.refetch()}>
          重试
        </button>
      </div>
    )
  if (requiredRoles && !requiredRoles.includes(session.data.role))
    return <div className="p-8">权限不足</div>
  return <>{children}</>
}
